import styled from "styled-components";

export const ContentSwapper = styled.div`
  margin-top: 10px;
  background-color:#fff;
  padding: 10px;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  .more {
    display: flex;
    align-items: center;
    margin-top:10px;
    // padding:1rem 1rem;
  }
  .alert {
    color: #c010d7;
  }
`

export const LineFlex = styled.div`
display:flex;
justify-content:space-between;
align-items:center;
`
export const LineFlex1 = styled.div`
display:flex;
justify-content:space-between;
align-items:center;
gap:10px;
`
export const AdvancedStyle = styled.div`
display:flex;
flex-direction:column;
gap:10px;

`
export const LineStyle = styled.div`
  border-top: 1px solid #bcebf5;
`
export const ContentLink = styled.div`

  .content {
    display: flex;
    align-items: center;
    flex:1;
    gap:10px;
  }

  .moreswpper {
    display: flex;

    input {
      &:focus:not(:disabled) {
        box-shadow: none !important;
      }
    }
  }
  .price {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex:1;
  }
  .marginleft20 {
    margin-left: 20px;
  }
  // .checkbox {
  //   input {
  //     border: 1px solid #d7caec;
  //     &:focus:not(:disabled) {
  //       box-shadow: 0px 0px 0px 1px #9a84c8, 0px 0px 0px 1px rgb(118 69 217 / 60%);
  //     }
  //   }
  // }

  @media (max-width: 768px) {
    .content {
      input {
        width: 100%;
      }
    }
    .price {
      width: 100%;
    }
  }
`

export const ContentItem = styled.div`
  // padding-bottom: 8px ;

  input {
    // border: 1px solid #d7caec;
    &:focus:not(:disabled) {
      box-shadow: 0px 0px 0px 1px #9a84c8, 0px 0px 0px 1px rgb(118 69 217 / 60%);
    }
  }
  
  .pairtype {
    position: relative;
     
    .morepairtype{
      display: none;
      width: 100%;
      top:100%;
      position: absolute;
      z-index: 1000;
      background-color:#fff;
      border: 1px solid #e5e5e5;
      border-radius: 10px;
      &:hover {
        display: block;
      }

      div {
        padding: 5px;
        width:100%;
        border-radius: 10px;

        &:hover {
          background-color: #f2f5f7;
        }
      }
    }
  }
`